import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-clock",
  "use": "icon-clock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-clock\"><path d=\"M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm0 20.134A9.135 9.135 0 012.866 12 9.136 9.136 0 0112 2.866 9.135 9.135 0 0121.134 12 9.135 9.135 0 0112 21.134z\" /><path d=\"M16.29 15.108l-3.502-2.531V6.5a.197.197 0 00-.196-.196H11.41a.197.197 0 00-.197.196v6.762c0 .064.03.123.081.16l4.062 2.96a.198.198 0 00.275-.041l.702-.958a.196.196 0 00-.044-.274z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol